import * as React from 'react';

import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { useCdpContext } from 'state/cdp';
import { CustomEventNames, EVENT_PAGE_NAMES } from 'state/cdp/constants';
import { useLocationContext } from 'state/location';
import { routes } from 'utils/routing';

import { DesktopCrown, MobileCrown } from './logged-out-state-crown';
import {
  ButtonLabel,
  ContentContainer,
  DescriptionText,
  SignupButton,
  SignupButtonContainer,
  SignupContainer,
  SignupTextContainer,
  TextPartContainer,
  TitleText,
} from './offers-rewards-logged-out-state.styled';

export const LoggedOutView = () => {
  const { formatMessage } = useIntl();

  const { logNavigationClick } = useCdpContext();

  const { location, setPreviousPageName } = useLocationContext();

  const logSignUpEvent = () => {
    setPreviousPageName(EVENT_PAGE_NAMES.RewardsOffers);
    logNavigationClick(CustomEventNames.BUTTON_CLICK, {
      Name: 'Rewards Sign Up',
      CurrentPath: location.pathname,
      PathTo: routes.signUp,
    });
  };

  return (
    <>
      <ContentContainer>
        <SignupContainer>
          <SignupTextContainer>
            <TextPartContainer>
              <TitleText>{formatMessage({ id: 'rewardsWaiting' })}</TitleText>
              <DescriptionText>{formatMessage({ id: 'rewardsLogin' })}</DescriptionText>
            </TextPartContainer>
          </SignupTextContainer>
          <SignupButtonContainer>
            <Link to={routes.signUp} onClick={logSignUpEvent} style={{ textDecoration: 'none' }}>
              <SignupButton>
                <ButtonLabel>{formatMessage({ id: 'signUpToRedeem' })}</ButtonLabel>
              </SignupButton>
            </Link>
          </SignupButtonContainer>
        </SignupContainer>

        <MobileCrown />
        <DesktopCrown />
      </ContentContainer>
    </>
  );
};
